import { useState } from 'react';
import { Columns, FoldPanel, Radio, Specimens } from '@src/components';

export function RadioSection() {
  const [delivery, setDelivery] = useState('post');
  const [locked, setLocked] = useState('office');

  return (
    <FoldPanel
      id="radios"
      title="Radios"
      hint="One of a set. A real radio under a drawn mark, so grouping and tabbing stay the browser's. The selection colour when on, same as a ticked box."
      example={`<Radio
  name="delivery"
  value="post"
  label="Send by post"
  checked={delivery === 'post'}
  onCheckedChange={() => setDelivery('post')}
/>`}
    >
      <Specimens
        label="A group"
        note="Tab to each option, Enter or Space to choose. Arrows still move within the group."
      >
        <Columns columns="fill" gap={5}>
          <Radio
            name="delivery"
            value="post"
            label="Send by post"
            checked={delivery === 'post'}
            onCheckedChange={() => setDelivery('post')}
            hint="We'll ask for an address before the draw."
          />
          <Radio
            name="delivery"
            value="office"
            label="Leave it in the office"
            checked={delivery === 'office'}
            onCheckedChange={() => setDelivery('office')}
          />
          <Radio
            name="delivery"
            value="meetup"
            label="Hand it over in person"
            checked={delivery === 'meetup'}
            onCheckedChange={() => setDelivery('meetup')}
            error="In-person exchange is closed for this game."
          />
        </Columns>
      </Specimens>

      <Specimens
        label="Disabled"
        note="Both off and on, so a locked choice still reads as chosen."
      >
        <Columns columns="fill" gap={5}>
          <Radio
            name="locked"
            value="post"
            label="Send by post"
            checked={locked === 'post'}
            onCheckedChange={() => setLocked('post')}
            disabled
          />
          <Radio
            name="locked"
            value="office"
            label="Leave it in the office"
            checked={locked === 'office'}
            onCheckedChange={() => setLocked('office')}
            disabled
            hint="The organiser locked delivery."
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
